import { render, staticRenderFns } from "./Atendimento.vue?vue&type=template&id=af94804c&scoped=true&"
import script from "./Atendimento.vue?vue&type=script&lang=js&"
export * from "./Atendimento.vue?vue&type=script&lang=js&"
import style0 from "./Atendimento.vue?vue&type=style&index=0&id=af94804c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af94804c",
  null
  
)

export default component.exports